var locale = {
  placeholder: 'Select time'
};

export default locale;


//////////////////
// WEBPACK FOOTER
// ./~/ant-design-vue/es/time-picker/locale/en_US.js
// module id = 206
// module chunks = 0